<button
  #menuTrigger="matMenuTrigger"
  *ngIf="visible"
  class="clear"
  type="button"
  mat-icon-button
  [matMenuTriggerFor]="menu">
  <mat-icon class="main-menu">settings</mat-icon>
</button>
<div *ngIf="!visible" class="empty-menu"></div>

<mat-menu #menu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item type="button" color="primary" [matMenuTriggerFor]="convertMenu" *ngIf="currentTableSetting?.visibleActionMenu">
    <mat-icon fontSet="material-icons-outlined">save</mat-icon>
    <span>{{ languagePack.menuLabels.saveData }}</span>
  </button>

  <button
    mat-menu-item
    type="button"
    *ngIf="currentTableSetting?.visibleColumnSettingsMenu"
    (click)="onColumnSettingClick($event)">
    <mat-icon>view_column</mat-icon>
    <span>{{ languagePack.menuLabels.columnSetting }}</span>
  </button>
</mat-menu>

<!-- Convert Sub Menu -->
<mat-menu #convertMenu="matMenu">
  <button
    mat-menu-item
    type="button"
    (click)="onDownloadClick($event, 'JSON')"
    *ngIf="currentTableSetting?.visibleActionMenu?.json">
    <span>{{ languagePack.menuLabels.jsonFile }}</span>
  </button>

  <button
    mat-menu-item
    type="button"
    (click)="onDownloadClick($event, 'CSV')"
    *ngIf="currentTableSetting?.visibleActionMenu?.csv">
    <span>{{ languagePack.menuLabels.csvFile }}</span>
  </button>
</mat-menu>

<!-- Column Setting Sub Menu -->
<mat-menu #columnMenu="matMenu">
  <ng-container *ngIf="currentTableSetting?.columnSetting?.length > 0; else noColumns">
    <div
      class="va-mat-table-dragable-container"
      cdkDropList
      dkDropListLockAxis="y"
      cdkDropListOrientation="vertical"
      dir="ltr">
      <div
        *ngFor="let column of currentTableSetting?.columnSetting; let i = index"
        (click)="$event.stopPropagation(); $event.preventDefault()"
        class="dragable-row"
        cdkDrag
        [cdkDragData]="{ columnIndex: i, columnTitle: column.title }"
        (cdkDragDropped)="handleColumnMenuDropped($event)">
        <mat-icon cdkDragHandle>drag_indicator</mat-icon>
        <mat-checkbox
          class="column-config"
          [disabled]="column?.display === 'prevent-hidden'"
          [checked]="column?.display === 'visible' || column?.display === 'prevent-hidden'"
          (click)="$event.stopPropagation()"
          (change)="onToggleSelectedColumn(column)">
          {{ column.title }}
        </mat-checkbox>
        <div class="va-mat-table-drag-preview" *cdkDragPreview>
          <mat-icon>drag_indicator</mat-icon>
          <mat-checkbox [checked]="column?.display === 'visible'">
            {{ column.title }}
          </mat-checkbox>
        </div>
      </div>
    </div>

    <div class="column-config-apply">
      <button
        mat-menu-item
        type="button"
        color="primary"
        class="done-setting"
        (click)="onApplyClick($event)">
        <mat-icon color="primary">done</mat-icon>
      </button>
      <button
        mat-menu-item
        type="button"
        color="primary"
        class="done-setting"
        (click)="onCancelClick()">
        <mat-icon color="primary">clear</mat-icon>
      </button>
    </div>
  </ng-container>

  <ng-template #noColumns>
    <div mat-menu-item>
      {{ languagePack.menuLabels.thereIsNoColumn }}
    </div>
  </ng-template>
</mat-menu>

<mat-menu
  #columnSettingMenu="matMenu"
  [overlapTrigger]="false"
  style="padding: 10px !important">
  <div
    *ngIf="currentColumn !== null"
    (click)="$event.stopPropagation(); $event.preventDefault()"
    class="column-setting">
    <ng-container *ngIf="isVisible(currentTableSetting?.visibleActionMenu?.columnSettingFilter)">
      <div class="column-setting-header column-setting-header-first">
        <mat-icon color="primary">filter_alt</mat-icon>
        {{ languagePack.menuLabels.filterMode }}
      </div>
      <mat-radio-group
        class="radio"
        [(ngModel)]="currentTableSetting.columnSetting[currentColumn].filter">
        <mat-radio-button
          value="client-side"
          (click)="$event.stopPropagation()">
          {{ languagePack.menuLabels.filterLocalMode }}
        </mat-radio-button>
        <mat-radio-button
          value="server-side"
          (click)="$event.stopPropagation()">
          {{ languagePack.menuLabels.filterServerMode }}
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>

    <ng-container *ngIf="isVisible(currentTableSetting?.visibleActionMenu?.columnSettingSort)">
      <div class="column-setting-header">
        <mat-icon color="primary">sort</mat-icon>
        {{ languagePack.menuLabels.sortMode }}
      </div>
      <mat-radio-group
        class="radio"
        [(ngModel)]="currentTableSetting.columnSetting[currentColumn].sort">
        <mat-radio-button
          (click)="$event.stopPropagation()"
          value="client-side">
          {{ languagePack.menuLabels.sortLocalMode }}
        </mat-radio-button>
        <mat-radio-button
          value="server-side"
          (click)="$event.stopPropagation()">
          {{ languagePack.menuLabels.sortServerMode }}
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>
  </div>
</mat-menu>
